// extracted by mini-css-extract-plugin
export var body = "_2m-1";
export var bodyPadded = "_2m-2";
export var chevron = "_2m-4";
export var chevronOpen = "_2m-5";
export var header = "_2m-0";
export var icon = "_2m-3";